/** 配送先分析で選んだ作業・配送先。CSV も同じ範囲を出す（ADM-12）。 */
export interface ClientSelection {
  taskId: string | null;
  clientIds: string[];
}

/**
 * ADM-12。対象の配送先＝選んだ配送先（未選択なら全件）のうち、選んだ作業が割り当てられたもの。
 * 一覧・グラフ・CSV で同じ判定を使う。
 */
export function isTargetClient(
  client: { id: number | string; tasks?: (number | string)[] },
  selection: ClientSelection
): boolean {
  if (selection.clientIds.length > 0 && !selection.clientIds.map(String).includes(String(client.id))) {
    return false;
  }
  if (selection.taskId !== null && selection.taskId !== undefined) {
    return (client.tasks ?? []).map(String).includes(String(selection.taskId));
  }
  return true;
}
